import { componentModel } from '../../models';

export const createComponentMachine = (defaultContext = {}) =>
  componentModel.createMachine({
    predictableActionArguments: true,
    context: {
      ...componentModel.initialContext,
      ...defaultContext,
    },
  });
